import { createApp } from 'vue'
import App from './components/toolbar/toolbar.vue'

/**
 * Dependences imported
 */
import animate from 'animate.css'

import toolbar from './components/toolbar/toolbar.vue'
import toast from './components/toast/toast.vue'
import transitionStaggered from './components/transitions/transitionStaggered'
import interceptors from './components/interceptors/interceptors'
import maintenance from './components/maintenance/maintenance'
import addPeopleInputGeneric from './components/genericComponents/addPeopleInputGeneric/addPeopleInputGeneric'
import popupPersonalInfoGeneric from './components/genericComponents/popupPersonalInfoGeneric/popupPersonalInfoGeneric'
import createCollectionModalGeneric from './components/genericComponents/createCollectionModalGeneric/createCollectionModalGeneric'
import addRemoveItemsToCollectionGeneric from './components/genericComponents/addRemoveItemsToCollectionGeneric/addRemoveItemsToCollectionGeneric'
import peopleListModalGeneric from './components/genericComponents/peopleListModalGeneric/peopleListModalGeneric'
import highLightModalGeneric from './components/genericComponents/highLightModalGeneric/highLightModalGeneric'
import deleteCommentModalGeneric from './components/genericComponents/deleteCommentModalGeneric/deleteCommentModalGeneric'
import backToTopButton from './components/backToTopButton/backToTopButton'

/* eslint-disable */
import velocity from 'velocity-animate'
/* eslint-enable */

import VueInputAutowidth from 'vue-input-autowidth'
// import VueMaterial from 'vue-material'

/**
 *  Style dependences
 */
//import 'vue-material/dist/vue-material.min.css'

const app = createApp(App)
app.use(animate)
app.use(VueInputAutowidth)
// app.use(VueMaterial)

const greyComponents = {
  install: (app, options) => {
    app.component('toolbar', toolbar)
    app.component('toast', toast)
    app.component('transitionStaggered', transitionStaggered)
    app.component('interceptors', interceptors)
    app.component('maintenance', maintenance)
    app.component('addPeopleInputGeneric', addPeopleInputGeneric)
    app.component('popupPersonalInfoGeneric', popupPersonalInfoGeneric)
    app.component('createCollectionModalGeneric', createCollectionModalGeneric)
    app.component('addRemoveItemsToCollectionGeneric', addRemoveItemsToCollectionGeneric)
    app.component('peopleListModalGeneric', peopleListModalGeneric)
    app.component('highLightModalGeneric', highLightModalGeneric)
    app.component('deleteCommentModalGeneric', deleteCommentModalGeneric)
    app.component('backToTopButton', backToTopButton)
  }
}

export default greyComponents
